import React from 'react';
import { content } from '../content';
import { GridViewIcon, ListViewIcon, MoonIcon, SunIcon } from './Icon';
import { SectionId, Theme, ViewMode } from '../types';
import '../styles/Topbar.css';

const { headings, ui } = content;

type TopbarProps = {
  section: SectionId;
  /** True while a blog article is open — it renders its own title block. */
  postOpen?: boolean;
  view: ViewMode;
  onViewChange: (view: ViewMode) => void;
  theme: Theme;
  onThemeToggle: () => void;
};

const Topbar = ({
  section,
  postOpen = false,
  view,
  onViewChange,
  theme,
  onThemeToggle,
}: TopbarProps) => {
  const heading = headings[section];
  // On the landing section the offer block below carries the `<h1>` — it is
  // the one heading that states an offer rather than naming a nav item — so
  // the section title steps down to `<h2>` there and stays `<h1>` elsewhere.
  const Title = section === 'projects' ? 'h2' : 'h1';

  return (
    <header className={`topbar${postOpen ? ' topbar--bare' : ''}`}>
      {/* An open article states its own headline right below. Repeating
          "Блог. Разборы задач..." above it pushes the real title down the
          screen and says nothing the reader did not just click. */}
      {!postOpen && (
      <div className="topbar__intro">
        <Title className="topbar__title">
          {heading.title}
          <span className="dot">.</span>
        </Title>
        <p className="topbar__subtitle">
          {heading.subtitle.map((line, index) => (
            <React.Fragment key={line}>
              {index > 0 && <br />}
              {line}
            </React.Fragment>
          ))}
        </p>
      </div>
      )}

      <div className="topbar__controls">
        {section === 'projects' && (
          <>
            <span className="topbar__label">{ui.viewLabel}</span>
            <div className="segmented" role="group" aria-label={ui.viewGroupLabel}>
              <button
                type="button"
                className={`segmented__btn${view === 'grid' ? ' segmented__btn--active' : ''}`}
                aria-pressed={view === 'grid'}
                aria-label={ui.viewGrid}
                onClick={() => onViewChange('grid')}
              >
                <GridViewIcon size={17} />
              </button>
              <button
                type="button"
                className={`segmented__btn${view === 'list' ? ' segmented__btn--active' : ''}`}
                aria-pressed={view === 'list'}
                aria-label={ui.viewList}
                onClick={() => onViewChange('list')}
              >
                <ListViewIcon size={17} />
              </button>
            </div>
          </>
        )}

        <button
          type="button"
          className="icon-btn"
          aria-label={theme === 'dark' ? ui.themeToLight : ui.themeToDark}
          onClick={onThemeToggle}
        >
          {theme === 'dark' ? <SunIcon size={17} /> : <MoonIcon size={17} />}
        </button>
      </div>
    </header>
  );
};

export default Topbar;
